import { InspectionCompany } from 'api';
import { Chip, type GridColDef } from 'ui';

const formatInspectors = (params: {
  value:
    | {
        id: number;
        name: string;
        is_active?: boolean;
      }[]
    | null;
}) => {
  return params.value?.map((value) => value.name).join(', ') || 'N/A';
};

export const columns: GridColDef<InspectionCompany>[] = [
  {
    field: 'name',
    flex: 1,
    headerName: 'Name',
  },
  {
    field: 'is_active',
    headerName: 'Status',
    renderCell: (params) => {
      return (
        <Chip
          color={params.value ? 'success' : 'error'}
          variant="outlined"
          label={params.value ? 'Active' : 'Inactive'}
        />
      );
    },
  },
  {
    field: 'inspectors',
    flex: 2,
    headerName: 'Inspectors',
    sortable: false,
    valueFormatter: formatInspectors,
  },
];
